import React from 'react';
import ServiceCard from '../Services/ServiceCard';
import { api } from '../../services/api';
import { useContentList } from '../../hooks/useContent';
import { useSiteContent, sectionField } from '../../hooks/useSiteContent';

function OfferTwo() {
    const { items: services, loading } = useContentList(
        () => api.getServices({ per_page: 100 }),
        []
    );
    const { content } = useSiteContent('about');
    const subtitle = sectionField(content, 'services', 'subtitle', 'Services We Offer');
    const title = sectionField(content, 'services', 'title', 'Our Amazing services');

    if (loading || !services.length) {
        return null;
    }

    return (
        <section
            className="position-relative overflow-hidden space-bottom"
            id="destination-sec"
        >
            <div className="container">
                <div className="title-area text-center">
                    <span className="sub-title">{subtitle}</span>
                    <h2 className="sec-title">{title}</h2>
                </div>
                <div className="row gy-4 gx-4">
                    {services.map((service) => (
                        <div key={service.id} className="col-xl-3 col-lg-4 col-md-6">
                            <ServiceCard
                                serviceID={service.id}
                                serviceImage={service.image}
                                serviceTitle={service.title}
                                serviceItem={service.item}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default OfferTwo;
